import { Divider } from 'native-base';
import React from 'react';
import { Heading, Layout } from '../../components/core';
import {
  PageContent,
  PageFooter,
  PageHeader,
  PageLoading,
  PageTopBar,
} from '../../components/page';
import { useHubOrganizationResourcesQuery } from '../../graphQL';
import { useNavigate } from '../../routes';
import { getStylesheet } from '../../styles';
import { visuallyHiddenFloatStyle } from '../../utils/accessibility';
import { useTitle } from '../../utils/useTitle';
import { CampusResource } from '../campusResources/components/CampusResource';
import { AdditionalResources } from './components/AdditionalResources';

export const CrisisResourcesPage = (): JSX.Element => {
  useTitle('Crisis Resources');

  const navigate = useNavigate();
  const { data: hubUserOrgResourcesData, loading } = useHubOrganizationResourcesQuery();

  if (loading) {
    return <PageLoading pageName="resources" />;
  }

  const resources = hubUserOrgResourcesData?.hubOrganizationResources ?? [];
  const crisisResources = resources.filter(resource => resource.showAsCrisisResource);
  const orgHasResources = crisisResources.length > 0;

  const onBackPress = (): void => {
    navigate(-1);
  };

  const listHeadingId = 'crisis-resources-heading';

  return (
    <PageContent testID="crisis-resources-page">
      <PageTopBar backAccessibilityLabel="Back" backTitle="Back" onBackPress={onBackPress} />

      <PageHeader
        title="Get Help Now"
        undertext="If you or anyone you know are in a crisis or may be in danger, the following resources can
          provide you with immediate help."
      />

      <Layout.VStack
        {...styles.resourcesStack}
        divider={<Divider aria-hidden backgroundColor="secondary.alpha.10:alpha.10" />}
        space={10}
      >
        {orgHasResources && (
          <Layout.VStack>
            <Heading.h4 {...visuallyHiddenFloatStyle} level={2} id={listHeadingId}>
              Crisis Resources
            </Heading.h4>

            <Layout.Flex aria-labelledby={listHeadingId} role="list">
              {crisisResources.map(resource => (
                <CampusResource key={resource.name} headingLevel={3} resource={resource} />
              ))}
            </Layout.Flex>
          </Layout.VStack>
        )}

        <AdditionalResources orgHasResources={orgHasResources} />
      </Layout.VStack>

      <PageFooter />
    </PageContent>
  );
};

const styles = getStylesheet({
  resourcesStack: {
    paddingTop: 10,
  },
});
